module.exports = __webpack_public_path__ + "media/assets/svg/components/dots-2-0a83e9edb8c581b00784b58c5fd5d80b.svg";